"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
require("../../foundations/color-palette");
require("../../foundations/fonts");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["external", "children"];
var _templateObject;
var LinkStyles = _styledComponents.default.a(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  color: var(--bf-core-teal, teal);\n\n  &:visited {\n    color: var(--bf-dark-pink, pink);\n  }\n"])));
var Link = function Link(_ref) {
  var external = _ref.external,
    children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var externalProps = external ? {
    rel: "noopener",
    target: "_blank"
  } : {};
  return _react.default.createElement(LinkStyles, Object.assign({}, externalProps, rest), children);
};
var _default = Link;
exports.default = _default;